<template>
  <div :style="wrapperStyle">
    <a
      :href="`#${item.id}`"
      :class="linkClass"
    >
      {{ item.text }}
    </a>
    <template v-if="item.children && item.children.length > 0">
      <TableOfContentsItem
        v-for="child in item.children"
        :key="child.id"
        :item="child"
        :level="level + 1"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import type { ContentToken } from './tableOfContents.types';

  const props = defineProps<{
    item: ContentToken;
    level: number;
  }>();

  const linkClass = computed(() =>
    props.level > 0 ? 'post__contents-item post__contents-item--h3' : 'post__contents-item',
  );

  const wrapperStyle = computed(() => (props.level > 0 ? 'margin-top: 12px; margin-left: 24px;' : 'margin-top: 12px;'));
</script>
